import { FilterTypes } from 'app/components/filters/types';
import { validationTranslations, customFilterFieldPostfix } from './constants';
import { Filter } from '../types';

import get from 'lodash/get';

const matchNumberAndSeparators = /^[\d ,<>\-]+$/m;

const numberFieldValidation = (filter: Filter) => (data: any, translation: (id: number) => string) => {

  const valueKey = filter.id + customFilterFieldPostfix.number;
  const value = get(data, `${valueKey}.value`);
  const validateMissingValue = filter.required && !value;

  return !!value && !(matchNumberAndSeparators.test(value))
    ? { field: valueKey, message: translation(validationTranslations.number_or_separator) }
    : validateMissingValue && { field: valueKey, message: translation(validationTranslations.required_field) };
};

const decimalNumberFieldValidation = (filter: Filter) => (data: any, translation: (id: number) => string) => {

  const valueKeyDecimalFrom = filter.id + customFilterFieldPostfix.decimalFrom;
  const valueDecimalFrom = get(data, `${valueKeyDecimalFrom}.value`);
  const valueKeyDecimalTo = filter.id + customFilterFieldPostfix.decimalTo;
  const valueDecimalTo = get(data, `${valueKeyDecimalTo}.value`);
  
  const validateMissingValue = filter.required && (!valueDecimalFrom && !valueDecimalTo);
  const valueKeyFieldToValidateDecimalFrom = !valueDecimalFrom && !valueDecimalTo && valueKeyDecimalFrom;
  const valueKeyFieldToValidateDecimalTo = !valueDecimalFrom && !valueDecimalTo && valueKeyDecimalTo;
 
  return validateMissingValue ? 
    [{ field: valueKeyFieldToValidateDecimalFrom, message: translation(validationTranslations.required_field) },
      { field: valueKeyFieldToValidateDecimalTo, message: translation(validationTranslations.required_field) }] 
    : undefined;
};

const predefDateFieldValidation = (filter: Filter) => (data: any, translation: (id: number) => string) => {

  const valueKey = filter.id + customFilterFieldPostfix.predefDate;
  const value = get(data, `${valueKey}.value`);
  const validateMissingValue = filter.required && !value;

  return validateMissingValue ? { field: valueKey, message: translation(validationTranslations.required_field) } : undefined;
};

const dateFieldValidation = (filter: Filter) => (data: any, translation: (id: number) => string) => {

  const valueKeyFixedPeriod = filter.id + customFilterFieldPostfix.fixedPeriod;
  const valueFixedPeriod = get(data, `${valueKeyFixedPeriod}.value`);

  const valueKeyDateIntervalFrom = filter.id + customFilterFieldPostfix.dateIntervalFrom;
  const valueDateIntervalFrom = get(data, `${valueKeyDateIntervalFrom}.value`);

  const valueKeyDateIntervalTo = filter.id + customFilterFieldPostfix.dateIntervalTo;
  const valueDateIntervalTo = get(data, `${valueKeyDateIntervalTo}.value`);

  const validateMissingValue = filter.required && (!valueFixedPeriod && (!valueDateIntervalFrom && !valueDateIntervalTo));
  const isFixedPeriodSelected = !!get(data, `${valueKeyFixedPeriod}`);
  const valueKeyToValidateFixedOrDecimalFrom = isFixedPeriodSelected ? valueKeyFixedPeriod : valueKeyDateIntervalFrom;
  const valueKeyToValidateDecimalTo = !isFixedPeriodSelected && !valueDateIntervalFrom && valueKeyDateIntervalTo;

  return validateMissingValue ? 
    [{ field: valueKeyToValidateFixedOrDecimalFrom, message: translation(validationTranslations.required_field) },
      {field: valueKeyToValidateDecimalTo, message: translation(validationTranslations.required_field) }] : undefined;
};

const userProfileFieldValidation = (filter: Filter, data: any) => {

  const valueKey = filter.id + customFilterFieldPostfix.userProfile;
  const value = get(data, `${valueKey}.value`);

  return !!value?.length;
};

const fieldValidation = (filter: Filter) => (data: any, translation: (id: number) => string) => {

  const valueKey = filter.id;
  const value = get(data, `${valueKey}.value`);
  
  const hasValue = Array.isArray(value) ? !!value?.length : !!value;
  const hasUserProfileValue = filter.required && userProfileFieldValidation(filter, data);
  const validateMissingValue = filter.required && (!hasValue && !hasUserProfileValue);

  return validateMissingValue ? { field: valueKey, message: translation(validationTranslations.required_field) } : undefined;
};

export const createFilterValidation = (advancedSearchType: FilterTypes) => {

  const configuration = {
    [FilterTypes.NumberField]: numberFieldValidation,
    [FilterTypes.PredefDate]: predefDateFieldValidation,
    [FilterTypes.DateField]: dateFieldValidation,
    [FilterTypes.SelectMultipleHierarchy]: fieldValidation,
    [FilterTypes.TextField]: fieldValidation,
    [FilterTypes.MyLocation]: fieldValidation,
    [FilterTypes.SelectMultiple]: fieldValidation,
    [FilterTypes.CheckBox]: fieldValidation,
    [FilterTypes.DecimalNumber]: decimalNumberFieldValidation,
    [FilterTypes.MyUnit]: fieldValidation,
    [FilterTypes.Person]: fieldValidation,
    [FilterTypes.SelectMultipleFlat]: fieldValidation,
    [FilterTypes.SelectMultipleFlatWithCategories]: fieldValidation,
    [FilterTypes.SelectMultipleHierarchyWithCategories]: fieldValidation,
    [FilterTypes.SelectMultipleFlatSequentialWithCategories]: fieldValidation,
    [FilterTypes.SelectMultipleHierarchySequentialWithCategories]: fieldValidation
  };

  return configuration[advancedSearchType];
};
